import React, { Fragment } from 'react';

import { ValueBox, ValueGroup, ValueSelectInput } from '@candu-ai/craft/ui';
import { HANDLER_TYPES, NextTourStep, PreviousTourStep } from 'craft/types';

import { InteractionFieldProps } from './interactionFields';

const handlerTypes = [
  {
    value: HANDLER_TYPES.NEXT_TOUR_STEP as const,
    label: 'Next Tour Step',
  },
  {
    value: HANDLER_TYPES.PREVIOUS_TOUR_STEP as const,
    label: 'Previous Tour Step',
  },
];

type Handler = {
  value: typeof handlerTypes[number]['value'];
  label: string;
};

type TourAction = NextTourStep | PreviousTourStep;

export const TourField = React.memo(
  ({ defaultValue, onChange }: InteractionFieldProps<TourAction['handler']>) => {
    const defaultType = defaultValue?.type || HANDLER_TYPES.NEXT_TOUR_STEP;

    const onSetHandler = (selected: Handler | null) => {
      onChange({ type: selected?.value });
    };

    return (
      <Fragment>
        <ValueGroup>
          <ValueBox isInGroup={{ isLast: true }}>
            <ValueSelectInput<Handler>
              clearable={false}
              scale="small"
              items={handlerTypes}
              selectedItem={handlerTypes.find(({ value }) => value === defaultType)}
              onSelect={onSetHandler}
              calloutOffset="xxs"
            />
          </ValueBox>
        </ValueGroup>
      </Fragment>
    );
  },
);
